import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useMedia } from "react-use";
import { Button, MenuItem, Select } from "@mui/material";
import { SendIcon } from "@100mslive/react-icons";
import { config as cssConfig } from "@100mslive/roomkit-react";
import { SearchIcon } from "../../icons";
import { ToastManager } from "../Toast/ToastManager";
import { COMMUNITY_SERVICES } from "../../services";
import {
  AI_MODELS_LIST,
  GET_PUBLIC_SESSION,
  SET_PUBLIC_SESSION,
} from "../../common/constants";

const AIChatEditorExternal = () => {
  const isMobile = useMedia(cssConfig.media.sm);
  const [textSearch, setTextSearch] = useState("");
  const [searchData, setSearchData] = useState([]);
  const navigate = useNavigate();
  const sendQuery = () => {
    if (textSearch.trim()) {
      navigate("/ai/chat?q_ai=" + textSearch.trim());
    }
  };

  const [model, setModel] = useState(() => {
    let m = GET_PUBLIC_SESSION("EU_AI_MODEL");
    m = AI_MODELS_LIST?.[m] ? m : "claude-4-sonnet";
    return m;
  });

  useEffect(() => {
    if (model) {
      SET_PUBLIC_SESSION("EU_AI_MODEL", model);
    }
  }, [model]);
  const [displayText, setDisplayText] = useState("");
  const [charIndex, setCharIndex] = useState(0);
  const [isDeleting, setIsDeleting] = useState(false);
  const [wordIndex, setWordIndex] = useState(0);

  useEffect(() => {
    const questionsArray = [
      "Apple: How many iPhones did Apple sell in Q4?",
      "Tesla: What's Tesla's latest AI development?",
      "NVIDIA: Which companies are investing in AI chips?",
      "Microsoft: Compare Microsoft vs Google cloud revenue",
      "ASML: What's driving the semiconductor boom?",
      "Meta: How is Meta's metaverse strategy performing?",
      "Amazon: What's Amazon's AWS growth rate?",
      "Best AI stocks for 2025",
      "Which companies are leading in quantum computing?",
      "Shopify: How is e-commerce evolving in 2025?",
    ];
    const current = questionsArray[wordIndex];
    const typingSpeed = isDeleting ? 50 : 100;

    const handleTyping = () => {
      if (!isDeleting) {
        if (charIndex < current.length) {
          setCharIndex(prev => prev + 1);
          setDisplayText(current.substring(0, charIndex + 1));
        } else {
          setTimeout(() => setIsDeleting(true), 1500);
        }
      } else {
        if (charIndex > 0) {
          setCharIndex(prev => prev - 1);
          setDisplayText(current.substring(0, charIndex - 1));
        } else {
          setIsDeleting(false);
          setWordIndex(prev => (prev + 1) % questionsArray.length);
        }
      }
    };

    const timeout = setTimeout(handleTyping, typingSpeed);

    return () => clearTimeout(timeout);
  }, [charIndex, isDeleting, wordIndex]);

  useEffect(() => {
    if (textSearch?.trim()) {
      COMMUNITY_SERVICES.search({ search: textSearch })
        .then(data => {
          if (data.code === 200) {
            setSearchData(textSearch ? data.data?.list ?? [] : []);
          }
        })
        .catch(err => {
          ToastManager.addToast({ title: err.message });
        });
    } else {
      setSearchData([]);
    }
  }, [textSearch]);

  return (
    <div className="events-page-aichat-content-editor2">
      <div className="events-page-aichat-content-editor events-page-aichat-content-editor2-inner">
        <label
          htmlFor="company-search-input2"
          className="events-page-aichat-content-editor2-icon"
        >
          <SearchIcon />
        </label>
        <input
          id="company-search-input2"
          type="text"
          name="search"
          className="events-page-aichat-content-editor2-input"
          placeholder={displayText}
          value={textSearch}
          onChange={e => {
            setTextSearch(e.target.value);
          }}
          onKeyDown={e => {
            if (e.key === "Enter" && !e.shiftKey) {
              e.preventDefault();
              sendQuery();
            }
          }}
        />
        <div className="events-page-aichat-content-editor2-action">
          {!isMobile && (
            <Select
              name="model"
              className="custom-select custom-select-secondary"
              sx={{
                height: "36px",
                background: "transparent !important",
                border: "0px",
              }}
              value={model}
              onChange={e => {
                setModel(e.target.value);
              }}
              displayEmpty
            >
              {Object.keys(AI_MODELS_LIST)?.map((ml, index) => (
                <MenuItem key={index} value={ml}>
                  {AI_MODELS_LIST?.[ml]?.label}
                  <small className="text-secondary ml-auto">
                    &nbsp; &nbsp;
                    {AI_MODELS_LIST?.[ml]?.type}
                  </small>
                </MenuItem>
              ))}
            </Select>
          )}

          <Button
            onClick={() => {
              sendQuery();
            }}
            aria-label="Send message"
            color="primary"
            variant="outlined"
            size="small"
            sx={{ minWidth: "none" }}
            className="events6ix-btn events6ix-btn-sm events6ix-btn-secondary events-page-aichat-content-editor-action-btn"
          >
            <SendIcon />
          </Button>
        </div>
      </div>
      {searchData?.length && textSearch ? (
        <div className="event-page-explore-filter-search-result events-page-aichat-content-editor2-result">
          {searchData?.length > 0 ? (
            searchData.map((item, index) => (
              <Link
                key={index}
                to={`/company/${item?.orgSlug}`}
                className="event-page-explore-filter-search-result-item"
                onClick={() => setTextSearch("")}
              >
                {item?.orgStocks?.[0]?.symbol ? (
                  <>
                    <span className={item?._id ? "text-primary" : ""}>
                      {item?.orgStocks?.[0]?.symbol}
                    </span>{" "}
                    -{" "}
                  </>
                ) : item?.orgCoin?.symbol ? (
                  <>
                    <span className={item?._id ? "text-primary" : ""}>
                      {item?.orgCoin?.symbol}
                    </span>{" "}
                    -{" "}
                  </>
                ) : null}
                {item?.orgName}
              </Link>
            ))
          ) : (
            <div className="event-page-explore-filter-search-result-noItem">
              No search result found!
            </div>
          )}
        </div>
      ) : null}

      {isMobile && (
        <div className="events-page-aichat-content-editor2-action ml-auto mr-auto mt-10">
          <Select
            className="custom-select custom-select-secondary"
            sx={{
              height: "36px",
              background: "transparent !important",
              border: "0px",
            }}
            value={model}
            onChange={e => {
              setModel(e.target.value);
            }}
            displayEmpty
          >
            {Object.keys(AI_MODELS_LIST)?.map((ml, index) => (
              <MenuItem key={index} value={ml}>
                {AI_MODELS_LIST?.[ml]?.label}
                <small className="text-secondary ml-auto">
                  &nbsp; &nbsp;
                  {AI_MODELS_LIST?.[ml]?.type}
                </small>
              </MenuItem>
            ))}
          </Select>
        </div>
      )}
      <div className="events-page-aichat-content-editor2-text">
        Explore 50,000+ companies across 90 exchanges
      </div>
    </div>
  );
};

export default AIChatEditorExternal;
